export default class Carousels {
    constructor() {
        this.instance = self;
    }

    static init() {
        const self = new Carousels();
        self.attachEvents();
    }

    static initCarousel($carousel) {
        const self = new Carousels();
        self.attachSlick($carousel);
    }

    attachEvents() {
        const self = this;

        $(".js-carousel").each(function () {
            self.attachSlick($(this));
        });
    }

    attachSlick($carousel) {
        const self = this;

        if ($carousel.data("slick-initial-slide")) {
            $carousel.on(
                "init",
                function (event, slick, currentSlide, nextSlide) {
                    self.lazyLoadImages($(this));
                }
            );
        }

        $carousel.slick({
            autoplay: $carousel.data("slick-autoplay") || true,
            autoplaySpeed: $carousel.data("slick-autoplay-speed") || 5000,
            speed: $carousel.data("slick-speed") || 1000,
            slidesToShow: $carousel.data("slick-slides-to-show") || 1,
            slidesToScroll: $carousel.data("slick-slides-to-scroll") || 1,
            dots: $carousel.data("slick-dots") || false,
            appendDots: $carousel.data("slick-append-dots") || false,
            arrows: $carousel.data("slick-arrows") || false,
            fade: $carousel.data("slick-fade") || false,
            centerMode: $carousel.data("slick-center-mode") || false,
            centerPadding: $carousel.data("slick-center-mode") ? "27%" : false,
            useCSS: $carousel.data("slick-use-css") || false,
            swipe: $carousel.data("slick-swipe") || true,
            pauseOnHover: $carousel.data("slick-pause-on-hover") || false,
            pauseOnFocus: $carousel.data("slick-pause-on-hover") || false,
            vertical: $carousel.data("slick-vertical") || false,
            verticalSwiping: $carousel.data("slick-vertical") || false,
            infinite: $carousel.data("slick-infinite") || true,
            lazyLoad: "ondemand",
            adaptiveHeight: $carousel.data("slick-adaptive-height") || false,
            asNavFor: $carousel.data("slick-as-nav-for") || false,
            responsive: $carousel.data("slick-responsive") || [
                {
                    breakpoint: 992,
                    settings: {
                        arrows: false,
                        slidesToShow: 1,
                        slidesToScroll: 1,
                    },
                },
                {
                    breakpoint: 767,
                    settings: {
                        arrows: false,
                        slidesToShow: 1,
                        slidesToScroll: 1,
                    },
                },
            ],
        });

        // Ensuring any lazy loaded images in slick carousel are visible
        $carousel.on(
            "beforeChange",
            function (event, slick, currentSlide, nextSlide) {
                self.lazyLoadImages($(this), nextSlide);
            }
        );
    }

    lazyLoadImages($carousel, nextSlide) {
        const self = this,
            $nextSlide = $carousel.find(
                '[data-slick-index="' + nextSlide + '"]'
            );

        if ($nextSlide.length > 0) {
            let $image = $nextSlide.find("[data-slick-lazy-img]"),
                image = $image.get()[0];

            if (typeof image != "undefined") {
                let elementName = image.tagName.toLowerCase(),
                    imgSrc = image.getAttribute("data-slick-lazy-img");

                if (typeof imgSrc != "undefined" && imgSrc.length > 0) {
                    if (elementName == "img") {
                        image.src = imgSrc;
                    } else {
                        image.style.backgroundImage = "url(" + imgSrc + ")";
                    }
                }
            }
        }

        return self;
    }
}
